var _path, _path2, _path3, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSecurityUser(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.9671 7.4332L18.3338 13.6665C14.5005 15.0999 11.3672 19.6331 11.3672 23.7331V48.4998C11.3672 52.4331 13.9672 57.5998 17.1339 59.9665L31.4672 70.6665C36.1672 74.1999 43.9005 74.1999 48.6005 70.6665L62.9339 59.9665C66.1005 57.5998 68.7005 52.4331 68.7005 48.4998V23.7331C68.7005 19.6331 65.5671 15.0999 61.7338 13.6665L45.1005 7.4332C42.2672 6.39987 37.7338 6.39987 34.9671 7.4332Z",
    stroke: "url(#paint0_linear_676_66)",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M40.0005 36.3994C39.8672 36.3994 39.7005 36.3994 39.5672 36.3994C36.4338 36.2994 33.9338 33.6994 33.9338 30.5327C33.9338 27.2994 36.5672 24.666 39.8005 24.666C43.0339 24.666 45.6672 27.2994 45.6672 30.5327C45.6339 33.7327 43.1339 36.2994 40.0005 36.3994Z",
    stroke: "url(#paint1_linear_676_66)",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M33.3668 45.7322C30.1668 47.8656 30.1668 51.3655 33.3668 53.4988C37.0001 55.9322 42.9668 55.9322 46.6001 53.4988C49.8001 51.3655 49.8001 47.8656 46.6001 45.7322C43.0001 43.2989 37.0335 43.2989 33.3668 45.7322Z",
    stroke: "url(#paint2_linear_676_66)",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_676_66",
    x1: 11.3672,
    y1: 42.4871,
    x2: 68.7005,
    y2: 42.4871,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F8A71F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCE623"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_676_66",
    x1: 33.9338,
    y1: 30.9727,
    x2: 45.6672,
    y2: 30.9727,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F8A71F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCE623"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_676_66",
    x1: 30.9668,
    y1: 50.0437,
    x2: 49.0001,
    y2: 50.0437,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F8A71F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCE623"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSecurityUser);
export default __webpack_public_path__ + "static/media/security-user.fd6e4956eb9cb6a400e37493d21b6ff6.svg";
export { ForwardRef as ReactComponent };